<template>
<div class="container-fluid">
    <div class="card footer">
        <div class="d-flex flex-row pt-2 pb-2 justify-content-around">
            <div class="p-1 col-2 ml-2 d-flex" id="people" @click="NavToPostedJobList('postedjobs')" :class="{'active': currentRoute === 'postedJobs'}">
                <img :src="postedSvg" class="img-fluid " alt="posted" title="Home"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Posted</label>
            </div>
            <!-- <div class="p-1 col-2 mr-2 d-flex" @click="routetoSavedJobspage()" :class="{'active': currentRoute === 'savedJobs'}">
                <img :src="savedSvg" class="img-fluid " title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Saved</label>
            </div> -->
            <div class="p-1 col-2 mr-2 d-flex" @click="routetoDraftJobspage()" :class="{'active': currentRoute === 'draftJobs'}">
                <img :src="draftSvg" class="img-fluid " alt="draft" title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Draft</label>
            </div>
            <div class="p-1 col-2 ml-2 d-flex" @click="routetoClosedJobspage()" :class="{'active': currentRoute === 'closedJobs'}">
                <img :src="closedSvg" class="img-fluid " alt="closed" title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Closed</label>
            </div>
            <div class="p-1 col-2 mr-2 d-flex" @click="showMore = !showMore">
                <img src="../assets/MoreFooter.svg" class="img-fluid " alt="more" title="Job" v-if="!showMore"/>
		        <img src="../assets/HideFooter.svg" class="img-fluid " alt="less" title="Job" v-if="showMore"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap" v-if="!showMore">More</label>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap" v-if="showMore">Hide</label>
            </div>
        </div>
        <div class="d-flex flex-row pt-2 pb-2 justify-content-around" v-if="showMore">
            <!-- <div class="p-1 col-2 ml-2 d-flex" @click="routetoClosedJobspage()" :class="{'active': currentRoute === 'closedJobs'}">
                <img :src="closedSvg" class="img-fluid " title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Closed</label>
            </div> -->
            <div class="p-1 col-2 ml-2 d-flex" @click="routetoDeletedJobspage()" :class="{'active': currentRoute === 'createdJobs'}">
                <img :src="deletedSvg" class="img-fluid " alt="deleted" title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Deleted</label>
            </div>
            <!-- <div class="p-1 col-2 mr-2 d-flex">
                <img :src="historySvg" class="img-fluid " title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">History</label>
            </div> -->
            <div class="p-1 col-2 d-flex" @click="routetoFindResumespage()" :class="{'active': currentRoute === 'findResumes'}">
                <img :src="findresumeSvg" width="30px"  alt="deleted" title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block text-nowrap">Find Resume</label>
            </div>
            <div class="p-1 col-2 mr-2 d-flex">
            </div>
            <div class="p-1 col-2 mr-2 d-flex">
            </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '../router.js'
import { bus } from "../main";
export default {
    data(){
        return{
            showMore : false,
            postedSvg : require('../assets/SidemenuPosted.svg'),
            savedSvg : require('../assets/SidemenuSaved.svg'),
            draftSvg : require('../assets/SidemenuDraft.svg'),
            closedSvg : require('../assets/SidemenuClosed.svg'),
            deletedSvg : require('../assets/SidemenuDeleted.svg'),
            historySvg : require('../assets/SidemenuHistory.svg'),
            findresumeSvg : require('../assets/Find_resumes.svg'),
            postavideomodalopen : false,
            currentRoute: '',
            selectElement: '',
            peopleSvg: null,
            homeSvg: null

        }
    },
    components: {
    },
    methods : {
        closeModal() {
            this.postavideomodalopen = false;
        },
        NavToPostedJobList(elementId){
            this.closetoggleMenu()
            this.$session.set("selectElement", 'postedjobs')
            this.selectElement = elementId
            this.$router.push({
                name : 'postedJobs'
            })
            bus.$emit('refreshPostedJobsList', true)
        },
        routetoDraftJobspage: function () {
            this.closetoggleMenu()
            this.$router.push({
                name : 'draftJobs'
            })
            bus.$emit('refreshDraftJobsList', true)
        },
        routetoDeletedJobspage: function () {
            this.closetoggleMenu()
            this.$router.push({
                name : 'createdJobs'
            })     
            bus.$emit('refreshDeletedJobsList', true)
        },
        routetoSavedJobspage : function() {
            this.closetoggleMenu()
            this.$router.push({
                name : 'savedJobs'
            })
        },
        routetoClosedJobspage : function() {
            this.closetoggleMenu()
            this.$router.push({
                name : 'closedJobs'
            })
            bus.$emit('refreshClosedJobsList', true)
        },
        routetoFindResumespage : function() {
            this.closetoggleMenu()
            this.$router.push({
                name : 'findResumes'
            })
            bus.$emit('refreshFindResumesList', true)
        },
        closetoggleMenu(){
            bus.$emit('closetogglesidemenu', true)
        },
        highlightCurrentRoute(){
            if(this.currentRoute === 'postedJobs' ){ 
                this.postedSvg = require('../assets/SidemenuPostedBlue.svg')
                this.savedSvg = require('../assets/SidemenuSaved.svg')
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            } else if(this.currentRoute === 'savedJobs' ){ 
                this.postedSvg = require('../assets/SidemenuPosted.svg')
                this.savedSvg = require('../assets/SidemenuSavedBlue.svg')
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            }else if(this.currentRoute ==='createdJobs'){  
                this.postedSvg = require('../assets/SidemenuPosted.svg')     
                this.savedSvg = require('../assets/SidemenuSaved.svg')        
                this.deletedSvg = require('../assets/SidemenuDeletedBlue.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            }else if(this.currentRoute ==='closedJobs'){
                this.savedSvg = require('../assets/SidemenuSaved.svg')
                this.postedSvg = require('../assets/SidemenuPosted.svg')  
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosedBlue.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            }else if(this.currentRoute ==='draftJobs'){
                this.savedSvg = require('../assets/SidemenuSaved.svg')
                this.postedSvg = require('../assets/SidemenuPosted.svg')  
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraftBlue.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            }else if(this.currentRoute === 'findResumes'){
                this.savedSvg = require('../assets/SidemenuSaved.svg')
                this.postedSvg = require('../assets/SidemenuPosted.svg')  
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes_blue.svg')
            }else{
                this.postedSvg = require('../assets/SidemenuPosted.svg')  
                this.savedSvg = require('../assets/SidemenuSaved.svg')
                this.deletedSvg = require('../assets/SidemenuDeleted.svg')
                this.closedSvg = require('../assets/SidemenuClosed.svg')
                this.draftSvg = require('../assets/SidemenuDraft.svg')
                this.historySvg = require('../assets/SidemenuHistory.svg')
                this.findresumeSvg = require('../assets/Find_resumes.svg')
            }
        },
    },
    watch: {
        '$route': function (from, to) {
            this.currentRoute = this.$router.currentRoute.name;
            this.highlightCurrentRoute();
        }
    },
    created() {
        this.currentRoute = this.$router.currentRoute.name;
        this.highlightCurrentRoute();
    }
}
</script>
<style scoped>
.footermodal{
    z-index: 1000 !important;
}
a{
    color: black;
}
#people:hover{
   background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}
.img-fluid{
    width: 25px !important;
}
.active{
  /* border: 2px solid #007AFF;  
  background-color: #d6e9ff  !important; */
   color: #007AFF !important;
   cursor: pointer;
}
#people:active{
  border: 2px solid #007AFF;  
  background-color: #d6e9ff;
}
@media (max-width: 430px) {
  .img-fluid{
    width: 22px !important;
   }
}
</style> 
